import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-dash-enterprise-auth',
  templateUrl: './dash-enterprise-auth.component.html',
  styleUrls: ['./dash-enterprise-auth.component.scss']
})
export class DashEnterpriseAuthComponent implements OnInit {

  googleSettings = {
    name : 'Google GSuite',
    id: 'GoogleCalendarProvider',
    clientId: '327602494914-uibj3rbb499l7a12htqlmkubahuvglof.apps.googleusercontent.com',
    authUri: 'https://accounts.google.com/o/oauth2/v2/auth',
    calendarUri: 'https://www.googleapis.com/calendar/v3/users/me/calendarList',
    calendarTitleProperty: 'summary',
    calendarArrayProperty: 'items',
    scopes: ['openid', 'profile', 'https://www.googleapis.com/auth/userinfo.email',
            'https://www.googleapis.com/auth/calendar.readonly', 'https://www.googleapis.com/auth/calendar.events'],
    nonce: false,
  };

  microsoftSettings = {
    name : 'Microsoft 365',
    id: 'MicrosoftCalendarProvider',
    clientId: '46ab8986-7733-4a05-bc74-26c33b66b550',
    authUri: 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize',
    calendarUri: 'https://graph.microsoft.com/v1.0/me/calendars',
    calendarTitleProperty: 'name',
    calendarArrayProperty: 'value',
    scopes: ['openid', 'profile', 'User.Read', 'Calendars.ReadWrite', 'Calendars.ReadWrite.Shared'],
    nonce: true
  };

  responseJson = null;
  code = null;
  token = null;
  calendars = null;


  constructor(private activatedRoute: ActivatedRoute, private router: Router) {
    this.activatedRoute.fragment.subscribe(fragment => {
      const response = new URLSearchParams(fragment);
      this.handleOAuthResponse(response.get('code'), response.get('state'), response.get('access_token'));
    });

    this.activatedRoute.queryParams.subscribe(params => {
        const code = params.code;
        const state = params.state;
        const token = params.access_token;
        this.handleOAuthResponse(code, state, token);
    });
  }

  handleOAuthResponse = (code, state, token) => {
    if (token && state) {
      this.code = code;
      this.token = token;

      let settings = {};
      if (state === 'GoogleCalendarProvider') {
        settings = this.googleSettings;
      } else if (state === 'MicrosoftCalendarProvider') {
        settings = this.microsoftSettings;
      }


      this.listCalendars(settings, token);
    }
  }

  authToken = async (code, state) => {
    try {
      const response = await fetch('https://api.get-dash.com/v1/oauth', {
        method: 'POST',
        mode: 'cors',
        body: JSON.stringify({
          id: state,
          code,
          redirect_uri: window.location.origin + '/dash-enterprise-auth'
        })
      });
      const responseText = await response.text();
      const jsonResponse = JSON.parse(responseText);
      this.responseJson = {
        access_token : jsonResponse.access_token,
        refresh_token : jsonResponse.refresh_token,
        provider : state
      };
      let settings;
      if (state === 'GoogleCalendarProvider') {
        settings = this.googleSettings;
      } else if (state === 'MicrosoftCalendarProvider') {
        settings = this.microsoftSettings;
      }

      this.calendars =  await this.listCalendars(settings, jsonResponse.access_token);
    } catch (err) {
      console.log(err);
      this.code = null;
    }

  }

  listCalendars = async (settings, accessToken) => {
    const calendars = [];
    let nextLink = null;

    do {
      let url = settings.calendarUri;
      if (nextLink) {
        url = nextLink;
      }

      const response = await fetch(url, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + accessToken
        },
      });
      const result = await response.json();
      if (result.error) {
        if (typeof window !== 'undefined') {
          alert(result.error.message);
        }
      } else {
        if (result['@odata.nextLink']) {
          nextLink = result['@odata.nextLink'];
        } else if (result.nextPageToken) {
          nextLink = settings.calendarUri + '?pageToken=' + result.nextPageToken;
        } else {
          nextLink = null;
        }
        for (const calendar of result[settings.calendarArrayProperty]) {
          calendars.push({
            title: calendar[settings.calendarTitleProperty],
            id: calendar.id,
          });
        }
      }
    }
    while (nextLink);

    this.calendars = calendars;
    return calendars;
  }

  ngOnInit() {

  }

  googleAuthUrl() {
    return this.getAuthUrl(this.googleSettings);
  }

  microsoftAuthUrl() {
    return this.getAuthUrl(this.microsoftSettings);
  }

  getAuthUrl(settings) {
    if (typeof window === 'undefined') {
      return '';
    }
    let url = settings.authUri;
    url += '?client_id=' + encodeURIComponent(settings.clientId);
    url += '&redirect_uri=' + encodeURIComponent(window.location.origin + '/dash-enterprise-auth');
    url += '&response_type=token';
    url += '&scope=' + encodeURIComponent(settings.scopes.join(' '));
    url += '&prompt=select_account';
    url += '&state=' + encodeURIComponent(settings.id);
    if (settings.nonce) {
      url += '&nonce=' + '598362';
    }
    return url;
  }

  hasCode() {
    return this.token !== null && typeof this.token !== 'undefined';
  }

  hasResponse() {
    return this.calendars !== null;
  }

  getJsonResponse() {
    return this.responseJson ? JSON.stringify(this.responseJson) : '';
  }

}
